<template>
  <div class="wchgData">
    <el-form
      ref="baseDataForm"
      :rules="baseDataRules"
      :disabled="!isEdit || $route.name == 'addDetailGoods'"
      :model="baseData"
      label-width="130px"
    >
      <div class="rowTitle">{{ this.$t('goods.form.basicInfo') }}</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="公司代码">
            <el-tooltip
              :disabled="!baseData.companyCode"
              class="item"
              effect="dark"
              :content="computedCompanyCode"
              placement="top"
            >
              <el-input v-model="computedCompanyCode" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="公司名称">
            <el-tooltip
              :disabled="!baseData.companyName"
              class="item"
              effect="dark"
              :content="computedCompanyName"
              placement="top"
            >
              <el-input v-model="computedCompanyName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间">
            <el-date-picker
              class="inputWidth"
              v-model="baseData.gmtCreate"
              value-format="yyyy-MM-dd"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建人">
            <el-input v-model="baseData.createByName" clearable disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="商品父类编码">
            <el-input v-model="baseData.parentProductNo" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称" prop="productChName">
            <el-tooltip
              :disabled="!baseData.productChName"
              class="item"
              effect="dark"
              :content="baseData.productChName"
              placement="top"
            >
              <el-input
                v-model="baseData.productChName"
                @blur="linkTextChange('productChName')"
                clearable
                maxlength="32"
                :disabled="!isEdit"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.productSearchCode')">
            <el-tooltip
              :disabled="!baseData.productSearchCode"
              class="item"
              effect="dark"
              :content="baseData.productSearchCode"
              placement="top"
            >
              <el-input v-model="baseData.productSearchCode" clearable maxlength="32"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.productEnName')" prop="productEnName">
            <el-tooltip
              :disabled="!baseData.productEnName"
              class="item"
              effect="dark"
              :content="baseData.productEnName"
              placement="top"
            >
              <el-input v-model="baseData.productEnName" clearable maxlength="32"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 进项税率 -->
        <el-col :span="12">
          <el-form-item :label="$t('goods.form.incomeTaxRate')" prop="valueAddedTaxCode">
            <el-select
              :placeholder="$t('goods.message.incomeTaxRate')"
              v-model="baseData.valueAddedTaxCode"
              filterable
              class="inputWidth"
              clearable
              @change="(val) => changeTax(val, 'valueAddedTaxRate')"
            >
              <el-option
                v-for="(item, index) in addedTaxRateOptions.filter((it) => it.taxType == 'IT')"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('goods.form.sellTaxRate')" prop="salesTaxCode">
            <el-select
              :placeholder="$t('goods.message.sellTaxRate')"
              v-model="baseData.salesTaxCode"
              filterable
              class="inputWidth"
              clearable
              @change="(val) => changeTax(val, 'salesTaxRate')"
            >
              <el-option
                v-for="(item, index) in taxCodeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="商品分类" prop="groupCategory">
            <tree-select
              style="width: 100%"
              ref="treeSelect"
              :model="baseData.groupCategory"
              :apiUrl="groupCategoryUrl"
              method="get"
              :currentValue="baseData.groupCategory ? baseData.groupCategory : null"
              :disabled="!isEdit"
              :returnType="'true'"
              @setSearchModal="setSearchModal"
              :isName="false"
              :defaultExpandLevel="0"
            ></tree-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="基本单位" prop="basicUnit">
            <el-tooltip
              :disabled="!baseData.basicUnit"
              class="item"
              effect="dark"
              :content="
                baseData.basicUnit && unitDictList.length > 0
                  ? unitDictList.find((item) => item.value === baseData.basicUnit).label
                  : ''
              "
              placement="top"
            >
              <el-select
                :placeholder="$t('goods.message.extendCompanyCode')"
                v-model="baseData.basicUnit"
                filterable
                class="inputWidth"
                @change="linkTextChange('basicUnit')"
                :disabled="!isEdit || getUnitDisabled()"
                clearable
              >
                <el-option
                  v-for="(item, index) in unitDictList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 海关信息 -->
      <div class="rowTitle">{{ this.$t('goods.form.customerInfo') }}</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="海关编码" prop="customsId">
            <!-- <el-tooltip :disabled="!baseData.customsId" class="item" effect="dark" :content="baseData.customsId" placement="top"> -->
            <search-table
              v-model="baseData.customsId"
              searchType="customs"
              :isMultiple="true"
              :isNeedMultipleValue="true"
              :currentValue="baseData.customsId || null"
              :checkRowKeys="[baseData.customsId]"
              @input="setPartnerParent"
            ></search-table>
          </el-form-item>
          <!-- </el-tooltip> -->
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.productZhName')" prop="productZhName">
            <el-tooltip
              :disabled="!baseData.productZhName"
              class="item"
              effect="dark"
              :content="baseData.productZhName"
              placement="top"
            >
              -->
              <el-input v-model="baseData.productZhName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.measureUnit1')" prop="measureUnit1">
            <el-input v-model="baseData.measureUnit1" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.measureUnit2')" prop="measureUnit2">
            <el-input v-model="baseData.measureUnit2" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.exportTaxRate')" prop="taxRefundRate">
            <el-input v-model="baseData.taxRefundRate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.importMfnTariffRate')" prop="importMfnTariffRate">
            <el-input v-model="baseData.importMfnTariffRate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('goods.form.importNormalTariffRate')"
            prop="importNormalTariffRate"
          >
            <el-input v-model="baseData.importNormalTariffRate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('goods.form.consumptionTaxRate')" prop="consumptionTaxRate">
            <el-input v-model="baseData.consumptionTaxRate" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 基本详细信息 -->
    <div class="rowTitle">{{ this.$t('商品子类信息') }}</div>
    <vxe-toolbar v-if="$route.name != 'goodsDetail' && $route.name != 'forbidenGoods'">
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent()">{{
          $t('goods.button.addRow')
        }}</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >{{ $t('goods.button.deleteRow') }}</vxe-button
        >
        <vxe-button type="primary" class="vxe-btn-delete" @click="handleCopy">复制</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-toolbar v-if="$route.name == 'forbidenGoods'">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="forbidChildren(1)"
          >{{ $t('goods.button.forbidChild') }}</vxe-button
        >
        <vxe-button type="primary" class="vxe-btn-primary" @click="solveForbidChildren(0)">{{
          $t('goods.button.solveForbidChild')
        }}</vxe-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="goodsTableData"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="productTableEditRules"
      @cell-click="cellClick"
      @edit-closed="linkTextChange"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <!-- <vxe-table-column
        field="productDetailCode"
        :title="$t('goods.table.productDetailCode')"
      ></vxe-table-column> -->
      <vxe-table-column field="productDetailCode" title="商品子类编码"></vxe-table-column>
      <vxe-table-column field="detailProductDisplayName" title="商品名称">
        <template v-slot="{ row }">{{ getDetailProductDisplayName(row) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="detailProductSearchCode"
        title="子类搜索简码"
        :edit-render="{
          name: 'ElInput',
          defaultValue: '',
          props: { clearable: true, maxlength: 32 },
        }"
      ></vxe-table-column>
      <vxe-table-column
        field="detailProductItems"
        title="品目"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:default="scope" v-if="userInfo.businessGroup == '园区'">{{
          scope.row.detailProductItems
        }}</template>
        <template v-slot:edit="scope">
          <el-select
            v-if="userInfo.businessGroup == '园区'"
            v-el-select-loadmore="loadmore('1')"
            v-model="scope.row.detailProductItemsId"
            :filter-method="detailProductItemsFilterMethod"
            @change="AttrChange(scope.row, 'detailProductItems')"
            @visible-change="(visible)=>selectVisibleChange(visible,'detailProductItems')"
            clearable
            filterable
          >
            <el-option
              v-for="(item) in detailProductItemsList.slice(0, rangeNumber1)"
              :key="'detailProductItems_'+ String(item.id)"
              :label="item.name"
              :value="String(item.id)"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <el-input v-else v-model="scope.row.detailProductItems" clearable maxlength="32" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="detailProductVendor"
        title="厂商"
        :edit-render="{
          name: 'ElInput',
          defaultValue: '',
          props: { clearable: true, maxlength: 32 },
        }"
      >
        <template v-slot:default="scope" v-if="userInfo.businessGroup == '园区'">
          {{ scope.row.detailProductVendor }}
        </template>
        <template v-slot:edit="scope">
          <el-select
            v-if="userInfo.businessGroup == '园区'"
            v-el-select-loadmore="loadmore('2')"
            v-model="scope.row.detailProductVendorId"
            :filter-method="detailProductVendorFilterMethod"
            @change="AttrChange(scope.row, 'detailProductVendor')"
            @visible-change="(visible)=>selectVisibleChange(visible,'detailProductVendor')"
            clearable
            filterable
          >
            <el-option
              v-for="(item) in detailProductVendorList.slice(0, rangeNumber2)"
              :key="'detailProductVendor_' + String(item.id)"
              :label="item.name"
              :value="String(item.id)"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <el-input v-else v-model="scope.row.detailProductVendor" clearable maxlength="32" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="detailProductOriginalPlace"
        title="产地"
        :edit-render="{ name: 'default' }"
      >
        <template v-slot:default="scope" v-if="userInfo.businessGroup == '园区'">
          {{ scope.row.detailProductOriginalPlace }}
        </template>
        <template v-slot:edit="scope">
          <el-select
            v-if="userInfo.businessGroup == '园区'"
            v-model="scope.row.detailProductOriginalPlaceId"
            v-el-select-loadmore="loadmore('3')"
            :filter-method="detailProductOriginalPlaceFilterMethod"
            @change="AttrChange(scope.row, 'detailProductOriginalPlace')"
            @visible-change="(visible)=>selectVisibleChange(visible,'detailProductOriginalPlace')"
            clearable
            filterable
          >
            <el-option
              v-for="(item) in detailProductOriginalPlaceList.slice(0, rangeNumber3)"
              :key="'detailProductOriginalPlace_' + String(item.id)"
              :label="item.name"
              :value="String(item.id)"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <el-input
            v-else
            v-model="scope.row.detailProductOriginalPlace"
            clearable
            maxlength="32"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column field="detailProductModel" title="规格" :edit-render="{ name: 'default' }">
        <template v-slot:default="scope" v-if="userInfo.businessGroup == '园区'">
          {{ scope.row.detailProductModel }}
        </template>
        <template v-slot:edit="scope">
          <el-select
            v-if="userInfo.businessGroup == '园区'"
            v-model="scope.row.detailProductModelId"
            v-el-select-loadmore="loadmore('4')"
            :filter-method="detailProductModelFilterMethod"
            @change="AttrChange(scope.row, 'detailProductModel')"
            @visible-change="(visible)=>selectVisibleChange(visible,'detailProductModel')"
            clearable
            filterable
          >
            <el-option
              v-for="(item) in detailProductModelList.slice(0, rangeNumber4)"
              :key="'detailProductModel_' + String(item.id)"
              :label="item.name"
              :value="String(item.id)"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <el-input v-else v-model="scope.row.detailProductModel" clearable maxlength="32" />
        </template>
      </vxe-table-column>
      <vxe-table-column field="detailProductPack" title="包装" :edit-render="{ name: 'default' }">
        <template v-slot:default="scope" v-if="userInfo.businessGroup == '园区'">
          {{ scope.row.detailProductPack }}
        </template>
        <template v-slot:edit="scope">
          <el-select
            v-if="userInfo.businessGroup == '园区'"
            v-model="scope.row.detailProductPacksId"
            v-el-select-loadmore="loadmore('5')"
            :filter-method="detailProductPackFilterMethod"
            @change="AttrChange(scope.row, 'detailProductPack')"
            @visible-change="(visible)=>selectVisibleChange(visible,'detailProductPack')"
            clearable
            filterable
          >
            <el-option
              v-for="(item) in detailProductPackList.slice(0, rangeNumber5)"
              :key="'detailProductPack_' + String(item.id)"
              :label="item.name"
              :value="String(item.id)"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <el-input v-else v-model="scope.row.detailProductPack" clearable maxlength="32" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="detailProductMaterial"
        title="材质"
        :edit-render="{ name: 'default' }"
      >
        <template v-slot:default="scope" v-if="userInfo.businessGroup == '园区'">
          {{ scope.row.detailProductMaterial }}
        </template>
        <template v-slot:edit="scope">
          <el-select
            v-if="userInfo.businessGroup == '园区'"
            v-model="scope.row.detailProductMaterialId"
            :filter-method="detailProductMaterialFilterMethod"
            v-el-select-loadmore="loadmore('6')"
            @change="AttrChange(scope.row, 'detailProductMaterial')"
            @visible-change="(visible)=>selectVisibleChange(visible,'detailProductMaterial')"
            clearable
            filterable
          >
            <el-option
              v-for="(item) in detailProductMaterialList.slice(0, rangeNumber6)"
              :key="'detailProductMaterial_' + String(item.id)"
              :label="item.name"
              :value="String(item.id)"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <el-input v-else v-model="scope.row.detailProductMaterial" clearable maxlength="32" />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="detailProductLevel"
        :title="$t('goods.table.detailProductLevel')"
        :edit-render="{
          name: 'ElInput',
          defaultValue: '',
          props: { clearable: true, maxlength: '32' },
        }"
      ></vxe-table-column> -->
      <!-- <vxe-table-column
        field="detailProductOther"
        :title="$t('goods.table.detailProductOther')"
        :edit-render="{
          name: 'ElInput',
          defaultValue: '',
          props: { clearable: true },
          maxlength: '32',
        }"
      ></vxe-table-column> -->
      <!-- <vxe-table-column
        field="detailProductDisplayName"
        :title="$t('goods.table.detailProductDisplayName')"
      >
        <template v-slot="{ row }">{{ getDetailProductDisplayName(row) }}</template>
      </vxe-table-column> -->
      <!-- <vxe-table-column
        field="detailProductSearchCode"
        :title="$t('goods.table.detailProductSearchCode')"
        :edit-render="{
          name: 'ElInput',
          defaultValue: '',
          props: { clearable: true, maxlength: '32' },
        }"
      ></vxe-table-column> -->
      <!-- <vxe-table-column
        field="detailProductInvoiceName"
        :title="$t('goods.table.detailProductInvoiceName')"
        :edit-render="{
          name: 'ElInput',
          defaultValue: '',
          props: { clearable: true, maxlength: '32' },
        }"
      ></vxe-table-column> -->
      <vxe-table-column
        field="overShippedPercentage"
        :title="$t('goods.table.overShippedPercentage')"
        :edit-render="{
          name: 'ElInputNumber',
          defaultValue: '',
          props: { clearable: true },
        }"
      ></vxe-table-column>
      <vxe-table-column
        field="shortShippedPercentage"
        :title="$t('goods.table.shortShippedPercentage')"
        :edit-render="{
          name: 'ElInputNumber',
          defaultValue: '',
          props: { clearable: true },
        }"
      ></vxe-table-column>
      <!-- <vxe-table-column
        field="detailProductStatusName"
        :title="$t('goods.table.detailProductStatusName')"
      ></vxe-table-column> -->
    </vxe-table>

    <div class="rowTitle">{{ this.$t('goods.form.dataPermision') }}</div>
    <!-- 数据使用权限表格-->
    <vxe-toolbar v-if="$route.name != 'goodsDetail' && $route.name != 'forbidenGoods'">
      <template v-slot:buttons>
        <!-- <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertCompany()"
          >{{ $t('goods.button.addRow') }}</vxe-button
        > -->
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertCompany()">{{
          $t('goods.button.addRow')
        }}</vxe-button>
        <!-- <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
        >{{$t('goods.button.deleteRow')}}</vxe-button>-->
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      :data="dataAuthTableData"
      :edit-config="editConfigAuth"
      size="mini"
      ref="dataAuthTable"
      :edit-rules="productTableEditRules"
      auto-resize
      @edit-closed="closeEditAuth"
      @edit-actived="changeCompanySelect"
    >
      <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
      <vxe-table-column
        field="extendCompanyCode"
        :title="$t('goods.table.personCompanyName')"
        :edit-render="{ type: 'ElSelect', props: { clearable: true } }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.extendCompanyCode"
            :disabled="scope.row.id"
            clearable
            @change="changeCompany(scope)"
            filterable
            class="selectAuth"
          >
            <el-option
              v-for="(item, index) in companyOptions"
              :key="index"
              :label="item.personCompanyName"
              :value="item.personCompanyCode"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.extendCompanyCode, companyOptions)
        }}</template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="permissionDepartmentName"
        :title="$t('goods.table.personDepartmentName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.permissionDepartmentCode"
            clearable
            :multiple="true"
            @change="(val) => changeSelect(val, scope.row)"
            @focus="getDepartmentoptions(scope)"
            filterable
            class="selectAuth"
          >
            <el-option
              v-for="(item, index) in departmentoptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span>{{$t('goods.message.all')}}</span>
        </template>
        <template v-slot="{ row }">
          {{ row.permissionDepartmentName }}
        </template>
      </vxe-table-column> -->
      <vxe-table-column
        v-if="userInfo.adminFlag == 1"
        field="dataStatus"
        :title="$t('goods.table.isUsed')"
        :edit-render="{ type: 'ElSelect', props: { clearable: true } }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.dataStatus"
            @change="$refs.dataAuthTable.updateStatus(scope)"
            clearable
            class="selectAuth"
            filterable
          >
            <el-option
              v-for="(item, index) in authOptions"
              :key="index"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ transferSelect(row.dataStatus, authOptions) }}</template>
      </vxe-table-column>
    </vxe-table>
    <check-repeat
      ref="repeatDialog"
      :productChName="baseData.productChName"
      :id="(goodsDetail || {}).id"
    />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SiruiTable from '@/components/SiruiTable';
  import SearchTable from '@/components/form-item/search-table';
  import checkRepeat from '@/pages/masterData/goods/dialog/checkRepeat.vue'; // 弹窗
  // import filters from '@/filters/index.js';
  import API from '@/api/masterData/goods';
  import BASE_API from '@/api/dataBase';
  import treeSelect from '@/components/form-item/tree-select';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import XEUtils from 'xe-utils';
  import Vue from 'vue';
  Vue.directive('el-select-loadmore', {
    //el指令所绑定的元素，可以用来直接操作 DOM
    //binding一个对象 binding.value指令的绑定值，此处指令的绑定值是loadMore()的值
    bind: function (el, binding) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      SELECTWRAP_DOM.addEventListener('scroll', function () {
        /**
         * scrollHeight 获取元素内容高度(只读)
         * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
         * clientHeight 读取元素的可见高度(只读)
         * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
         * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
         */
        const condition = this.scrollHeight - this.scrollTop >= this.clientHeight ? true : false;
        if (condition) binding.value();
      });
    },
  });
  export default {
    components: {
      // SiruiTable,
      checkRepeat,
      SearchTable,
      treeSelect,
    },
    name: 'wchgData',
    props: ['isEdit', 'isForbiden', 'goodsDetail', 'extendList', 'addedTaxRateOptions', 'addFlag'],
    data() {
      return {
        baseData: {
          // createBy: '',
          gmtCreate: '',
          productChName: '',
          productZhName: '',
          measureUnit1: '',
          measureUnit2: '',
          taxRefundRate: '',
          importMfnTariffRate: '',
          importNormalTariffRate: '',
          consumptionTaxRate: '',
          productEnName: '',
          salesTaxCode: '',
          salesTaxRate: '',
        },
        groupCategoryUrl: BASE_API.GET_PRODUCT_CAT_TREE,
        customslist: [], //海关编码下拉,为过滤前
        customsOptions: [], //海关编码下拉
        visible: false,
        editConfig: {},
        editConfigAuth: {},
        load: false,
        goodsTableData: [],
        dataAuthTableData: [],
        tableToolbar: {
          id: 'toolbar_demo_2',
          refresh: false,
          setting: false,
        },
        companyOptions: [], //可选公司下拉
        authOptions: [
          { key: '0', label: this.$t('goods.message.yes') },
          { key: '1', label: this.$t('goods.message.no') },
        ],
        ids: [], //有编码被删除的商品行
        productRepeatFlag: false, //商品名称是否重复标记
        productDetailsRepeatFlag: false, //商品明细是否重复标记
        departmentoptions: [], //部门列表
        unitDictList: [],
        detailProductItemsList: [],
        detailProductVendorList: [],
        detailProductOriginalPlaceList: [],
        detailProductModelList: [],
        detailProductPackList: [],
        detailProductMaterialList: [],
        rangeNumber1: 200,
        rangeNumber2: 200,
        rangeNumber3: 200,
        rangeNumber4: 200,
        rangeNumber5: 200,
        rangeNumber6: 200,
        attrList: {
          detailProductItemsList: [],
          detailProductVendorList: [],
          detailProductOriginalPlaceList: [],
          detailProductModelList: [],
          detailProductPackList: [],
          detailProductMaterialList: [],
        },
        // taxCodeList: [], // 销项税码列表
      };
    }, //detailProductstatus
    computed: {
      taxCodeList() {
        const taxList = this.addedTaxRateOptions.filter((it) => it.taxType == 'OT');
        taxList.map((item) => {
          item.value = item.value ? item.value : '99';
        });
        return taxList || [];
      },
      computedCompanyCode() {
        return this.addFlag ? this.userInfo.companyCode : this.baseData.companyCode;
      },
      computedCompanyName() {
        return this.addFlag ? this.userInfo.companyName : this.baseData.companyName;
      },
      baseDataRules() {
        return {
          // createBy: [
          //   {
          //     required: true,
          //     message: this.$t('goods.message.createBy'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          productChName: [
            {
              required: true,
              message: this.$t('goods.message.productChName'),
              trigger: ['blur', 'change'],
            },
          ],
          // productSearchCode: [
          //   {
          //     required: true,
          //     message: this.$t('goods.message.productSearchCode'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          // productEnName: [
          //   { required: true, message: this.$t('goods.message.productEnName'), trigger: ["blur", "change"] },
          // ],
          groupCategory: [
            {
              required: true,
              message: this.$t('goods.message.groupCategory'),
              trigger: ['blur', 'change'],
            },
          ],
          basicUnit: [
            {
              required: true,
              message: this.$t('goods.message.basicUnit'),
              trigger: ['blur', 'change'],
            },
          ],
          // valueAddedTaxCode: [
          //   {
          //     required: true,
          //     message: this.$t('goods.message.incomeTaxRate'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          // salesTaxCode: [
          //   {
          //     required: true,
          //     message: this.$t('goods.message.sellTaxRate'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          productCode: [
            {
              required: true,
              message: this.$t('goods.message.basicUnit'),
              trigger: ['blur', 'change'],
            },
          ],
          // customsId: [
          //   { required: true, message: this.$t('goods.message.customsId'), trigger: ["blur", "change"] },
          // ],
        };
      },
      productTableEditRules() {
        return {
          // detailProductOriginalPlace: [
          //   { required: true, message: this.$t('goods.message.detailProductOriginalPlace'), trigger: ["blur", "change"] },
          // ],
          // detailProductModel: [
          //   { required: true, message: this.$t('goods.message.detailProductModel'), trigger: ["blur", "change"] },
          // ],
          // detailProductLevel: [
          //   { required: true, message: this.$t('goods.message.detailProductLevel'), trigger: ["blur", "change"] },
          // ],
          // detailProductSearchCode: [
          //   {
          //     required: true,
          //     message: this.$t('goods.message.productSearchCode'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          // detailProductInvoiceName: [
          //   {
          //     required: true,
          //     message: this.$t('goods.message.detailProductInvoiceName'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          extendCompanyCode: [
            {
              required: true,
              message: this.$t('goods.message.extendCompanyCode'),
              trigger: ['blur', 'change'],
            },
          ],
          overShippedPercentage: [
            {
              required: true,
              message: this.$t('goods.message.overShippedPercentage'),
              trigger: ['blur', 'change'],
            },
          ],
          shortShippedPercentage: [
            {
              required: true,
              message: this.$t('goods.message.shortShippedPercentage'),
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      // this.getTaxCodeList();
      this.baseData.createByName = this.userInfo.personName;
      this.baseData.companyName = this.userInfo.companyName;
      // this.baseData.companyName = this.userInfo.companyName;
      this.baseData.tenantCode = this.userInfo.tenantCode;
      this.baseData.companyCode = this.userInfo.companyCode;
      this.baseData.gmtCreate = new Date();
      // 初始化表格是否编辑
      this.editConfig = this.isEdit ? { trigger: 'dblclick', mode: 'row' } : {};
      this.editConfigAuth = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.resolveData(); // 新增or修改执行不同数据策略
      this.getextendList(); //管理员获取多个公司的下拉
      this.determineSubclassesRejected();
      this.unitDictList = this.dictListMap?.basic_unit || [];
      if (this.userInfo.businessGroup == '园区') {
        this.getAllDetailCodeList();
      }
    },
    watch: {
      // 判断表格编辑功能是否禁用
      isEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'dblclick', mode: 'row' } : {};
      },
      goodsDetail(newData) {
        this.goodsDetail = newData;
        this.resolveData();
      },
    },
    methods: {
      AttrChange(row, field) {
        if (field == 'detailProductPack') {
          row[field] = this[field + 'List'].find(
            (item) => item.id == row['detailProductPacksId']
          )?.name;
        } else {
          row[field] = this[field + 'List'].find((item) => item.id == row[field + 'Id'])?.name;
        }
      },
      detailProductItemsFilterMethod(val) {
        this.filterMethod(val, 'detailProductItems');
      },
      detailProductVendorFilterMethod(val) {
        this.filterMethod(val, 'detailProductVendor');
      },
      detailProductOriginalPlaceFilterMethod(val) {
        this.filterMethod(val, 'detailProductOriginalPlace');
      },
      detailProductModelFilterMethod(val) {
        this.filterMethod(val, 'detailProductModel');
      },
      detailProductPackFilterMethod(val) {
        this.filterMethod(val, 'detailProductPack');
      },
      detailProductMaterialFilterMethod(val) {
        this.filterMethod(val, 'detailProductMaterial');
      },
      filterMethod(val, name) {
        if (val) {
          this[name + 'List'] = this.attrList[name + 'List'].filter(
            (item) => item.name.indexOf(val) > -1
          );
        } else {
          this[name + 'List'] = this.attrList[name + 'List'];
        }
      },
      selectVisibleChange(visible,name) {
        if(visible) this.filterMethod('',name)
      },
      loadmore(data) {
        return () => (this['rangeNumber' + data] += 200); //每次滚动到底部可以新增条数  可自定义
      },
      // getTaxCodeList() {
      //   console.log(this.addedTaxRateOptions, '123456');
      //   const taxList = this.addedTaxRateOptions.filter((it) => it.taxType == 'OT');
      //   // 脏数据处理
      //   taxList.map((item) => {
      //     item.value = item.value ? item.value : '99';
      //   });
      //   console.log(taxList, '11111111');
      //   this.taxCodeList = taxList;
      // },
      getAllDetailCodeList() {
        this.getDetailCodeList('01', 'detailProductItems');
        this.getDetailCodeList('02', 'detailProductVendor');
        this.getDetailCodeList('03', 'detailProductOriginalPlace');
        this.getDetailCodeList('04', 'detailProductModel');
        this.getDetailCodeList('05', 'detailProductPack');
        this.getDetailCodeList('06', 'detailProductMaterial');
      },
      getDetailCodeList(attrType, name) {
        this.$axios.post('/maindata/product/attr/list', { attrType }).then(({ data }) => {
          this.attrList[name + 'List'] = data.data;
          this[name + 'List'] = data.data;
        });
      },
      handleCopy() {
        const selectedList = this.$refs.goodsTable.getSelectRecords(); // 或许选中数据
        if (selectedList.length != 1) {
          this.$message({
            showClose: true,
            message: '请勾选一条数据！',
            type: 'error',
          });
          return;
        }
        let record = {
          productDetailCode: '',
          detailProductOriginalPlace: selectedList[0].detailProductOriginalPlace,
          detailProductModel: selectedList[0].detailProductModel,
          detailProductPack: selectedList[0].detailProductPack,
          detailProductMaterial: selectedList[0].detailProductMaterial,
          detailProductVendor: selectedList[0].detailProductVendor,
          detailProductOriginalPlaceId: selectedList[0].detailProductOriginalPlace,
          detailProductModelId: selectedList[0].detailProductModel,
          detailProductPacksId: selectedList[0].detailProductPack,
          detailProductMaterialId: selectedList[0].detailProductMaterial,
          detailProductVendorId: selectedList[0].detailProductVendor,
          // detailProductLevel: '',
          // detailProductOther: '',
          detailProductDisplayName: '',
          detailProductSearchCode: selectedList[0].detailProductSearchCode,
          // detailProductInvoiceName: '',
          overShippedPercentage: selectedList[0].overShippedPercentage,
          shortShippedPercentage: selectedList[0].shortShippedPercentage,
          detailProductItems: selectedList[0].detailProductItems,
          detailProductItemsId: selectedList[0].detailProductItems,
          productChName: selectedList[0].productChName,
        };
        this.$refs.goodsTable.insertAt(record, -1).then(({ row }) => {
          this.$refs.goodsTable.setActiveRow(row);
          this.$refs.goodsTable.clearCheckboxRow();
        });
        this.exportFirstData();
      },
      getUnitDisabled() {
        let status = ['ZT06', 'ZT05', ''];
        return this.goodsDetail ? !status.includes(this.goodsDetail.parentProductStatus) : false;
      },
      //子类跳转过来默认勾选子类
      setChildChecked() {
        // 默认勾选子类
        if (this.$route.query.productDetailCode) {
          let row = this.goodsTableData.find(
            (it) => it.productDetailCode == this.$route.query.productDetailCode
          );
          this.$refs.goodsTable.setCheckboxRow(row, true);
        }
      },
      getDetailProductDisplayName(row) {
        // row.detailProductDisplayName = this.baseData.productChName
        // let detailProductOriginalPlace = row.detailProductOriginalPlace
        //   ? '-' + row.detailProductOriginalPlace
        //   : '';
        // let detailProductModel = row.detailProductModel ? '-' + row.detailProductModel : '';
        // let detailProductLevel = row.detailProductLevel ? '-' + row.detailProductLevel : '';
        // let detailProductOther = row.detailProductOther ? '-' + row.detailProductOther : '';
        row.detailProductDisplayName = this.baseData.productChName;
        // detailProductOriginalPlace +
        // detailProductModel +
        // detailProductLevel +
        // detailProductOther;
        return row.detailProductDisplayName;
      },
      clearValidate() {
        this.$refs.baseDataForm.clearValidate();
      },
      changeSelect(val, row) {
        const nameList = [];
        for (let i = 0; i <= val.length - 1; i++) {
          this.departmentoptions.find((item) => {
            if (item.value == val[i]) {
              nameList.push(item.label);
            }
          });
        }
        if (nameList.length > 0) {
          row.permissionDepartmentName = nameList.toString();
        } else {
          row.permissionDepartmentName = '';
        }
        // row.permissionDepartmentName
        // this.departmentoptions
      },
      async getDepartmentoptions(scope) {
        if (scope.row.extendCompanyCode) {
          const { data } = await this.$axios.post(
            BASE_API.LIST_DEPARTMENT_API + '/' + scope.row.extendCompanyCode
          );
          if (0 == data.code) {
            this.$set(scope.row, 'departmentOptions', data.data);
            this.departmentoptions = data.data;
          } else {
            scope.row.departmentOptions = [];
          }
          this.$refs.dataAuthTable.updateStatus(scope);
        } else {
          this.departmentoptions = [];
        }
      },
      //进项 销项税码
      changeTax(val, model) {
        this.baseData[model] = this.addedTaxRateOptions.find((i) => i.value == val).taxRate;
      },
      setSearchModal(model, val) {
        this.baseData.groupCategory = val ? val.id : null;
        this.baseData.groupCategoryName = val ? val.label : null;
        if (val) {
          this.$refs.baseDataForm.clearValidate('groupCategory');
        }
      },
      //点击单元格的时候 根据不同需求判断改行是否能开启编辑
      cellClick(val) {
        if (this.$route.name == 'addDetailGoods' && val.row.productDetailCode) {
          //新增子类
          this.editConfig = val.row.productDetailCode ? {} : { trigger: 'dblclick', mode: 'row' };
        } else if (this.$route.name == 'editGoods') {
          let isStatic =
            val.row.detailProductStatus == 'ZT04' || val.row.detailProductStatus == 'ZT02';
          this.editConfig = !isStatic ? { trigger: 'dblclick', mode: 'row' } : {};
        } else {
          this.editConfig = this.isEdit ? { trigger: 'dblclick', mode: 'row' } : {};
        }
      },
      //远程搜索还是信息下拉
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          const params = {
            productZhName: query,
          };
          this.$axios.post(API.GET_CUSTOMS_LIST, params).then((res) => {
            if (res.data.code === 0) {
              this.loading = false;
              // this.customslist = this.states.map(item => {
              //   return { value: `value:${item}`, label: `label:${item}` };
              // })
              // this.customslist = res.data.data
              // this.customsOptions = this.customslist.filter(item => {
              //   return item.productCode.toLowerCase()
              //     .indexOf(query.toLowerCase()) > -1;
              // });

              this.customsOptions = res.data.data;
            }
          });
        } else {
          this.customsOptions = [];
        }
      },
      //删除海关信息，联动
      clearCustomsId() {
        this.baseData.productZhName = '';
        this.baseData.measureUnit1 = '';
        this.baseData.measureUnit2 = '';
        this.baseData.taxRefundRate = '';
        this.baseData.importMfnTariffRate = '';
        this.baseData.importNormalTariffRate = '';
        this.baseData.consumptionTaxRate = '';
        // this.baseData.productEnName='';
      },
      //选中还是信息编码 带出海事相关信息
      // customsChange(value) {
      //   this.clearCustomsId();
      //   this.getHaiShiInfo(value);//获取海事信息
      // },
      //获取还是信息
      getHaiShiInfo(value) {
        // let productEnName = this.baseData.productEnName;
        const params = {
          productCode: value,
        };
        if (!value) return;
        this.$axios.post(API.CUSTOMS_DET, params).then((res) => {
          if (res.data.code === 0) {
            // this.baseData = {
            //   ...this.baseData,
            //   ...res.data.data,
            //   productEnName: productEnName
            // }
            let data = res.data.data;
            this.baseData.productZhName = data.productZhName;
            this.baseData.measureUnit1 = data.measureUnit1;
            this.baseData.measureUnit2 = data.measureUnit2;
            this.baseData.taxRefundRate = data.taxRefundRate;
            this.baseData.importMfnTariffRate = data.importMfnTariffRate;
            this.baseData.importNormalTariffRate = data.importNormalTariffRate;
            this.baseData.consumptionTaxRate = data.consumptionTaxRate;
            // this.baseData.productEnName=productEnName;
          }
        });
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.noChooseDel'),
            type: 'error',
          });
          return;
        }
        //判断删除的是否含有有编码的
        let detailFlag = false;
        selectedList.map((item) => {
          if (item.productDetailCode) {
            detailFlag = true;
          }
        });
        if (detailFlag) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.cannotDeleteDataDetails'),
            type: 'error',
          });
          return;
        }
        const list = selectedList.map((v) => {
          v.idx = this.$refs[tableTpye].$getRowIndex(v);
          return v;
        });
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            selectedList.map((item) => {
              if (item.productDetailCode) {
                //如果有详细编码
                this.ids.push({
                  id: item.id,
                  version: item.version,
                  productDetailCode: item.productDetailCode,
                });
              }
            });
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('goods.message.delSuccess'),
            });
            this.exportFirstData(list);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('goods.message.unDel'),
            });
          });
      },
      //新增行
      insertEvent() {
        if (this.productDetailsRepeatFlag) {
          //有明细重复
          this.$message({
            showClose: true,
            message: this.$t('goods.message.duplicateItem'),
            type: 'error',
          });
          return;
        }
        let that = this;
        this.$refs['goodsTable'].validate((valid) => {
          if (valid) {
            let record = {
              productDetailCode: '',
              detailProductOriginalPlace: '',
              detailProductModel: '',
              detailProductPack: '',
              detailProductMaterial: '',
              // detailProductLevel: '',
              // detailProductOther: '',
              detailProductDisplayName: that.baseData.productChName,
              detailProductSearchCode: '',
              // detailProductInvoiceName: '',
              overShippedPercentage: '',
              shortShippedPercentage: '',
              detailProductItems: '',
              productChName: that.baseData.productChName,
            };
            this.$refs.goodsTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
            //that.$refs.goodsTable.insertAt(record)
            //that.$refs.goodsTable.setActiveCell(row, 'sex')
            that.exportFirstData();
          }
        });
      },
      //新增行
      insertCompany() {
        if (this.dataAuthTableData.length == this.companyOptions.length) {
          return this.$message({
            showClose: true,
            message: this.$t('goods.message.currentUsersCannotAdd'),
            type: 'error',
          });
        }
        let that = this;
        this.$refs['dataAuthTable'].validate((valid) => {
          if (valid) {
            let record = {
              extendCompanyName: '',
              extendCompanyCode: '',
              departmentName: '',
              dataStatus: '0',
              permissionDepartmentCode: [], //部门
              permissionDepartmentName: '',
            };
            this.companyOptions.forEach((item) => {
              this.dataAuthTableData.forEach((item2) => {
                if (item.personCompanyCode == item2.extendCompanyCode) {
                  item.disabled = true;
                }
              });
            });
            this.$refs.dataAuthTable
              .insert(record)
              .then(({ row }) => this.$refs.goodsTable.setActiveRow(row));
            that.changeAuthTable();
          }
        });
      },
      //改变数据权限表格数据
      changeAuthTable() {
        var dataAuthTableData = this.$refs.dataAuthTable.getTableData().fullData;
        this.dataAuthTableData = dataAuthTableData;
        this.$emit('changeAuth', dataAuthTableData);
      },
      //修改权限表格里面的公司
      changeCompany(row) {
        let companyName = '';
        companyName = this.transferSelect(row.row.extendCompanyCode, this.companyOptions);
        //修改公司 部门要清空
        row.row.permissionDepartmentName = '';
        row.row.permissionDepartmentCode = [];
        this.companyOptions.forEach((item) => {
          item.disabled = false;
          this.dataAuthTableData.forEach((item2) => {
            if (item.personCompanyCode == item2.extendCompanyCode) {
              item.disabled = true;
              return;
            }
          });
        });
        this.$refs.dataAuthTable.updateStatus();
        this.getDepartmentoptions(row);
        this.$emit('changeCompany', row.row.extendCompanyCode, companyName, row.$rowIndex);
      },
      closeEditAuth(row) {
        let companyName = '';
        companyName = this.transferSelect(row.row.extendCompanyCode, this.companyOptions);
        this.$emit('changeCompany', row.row.extendCompanyCode, companyName, row.$rowIndex);
      },
      setPartnerParent(val) {
        if (val && val.length > 0) {
          this.clearCustomsId();
          this.getHaiShiInfo(val[0].productCode); //获取海事信息
          this.baseData.productZhName = val[0].productZhName;
          this.baseData.customsId = val[0].productCode;
        } else {
          this.clearCustomsId();
        }
      },
      //修改选中的公司
      changeCompanySelect(value) {
        this.getDepartmentoptions(value);
        this.$refs.dataAuthTable.updateStatus();
        this.companyOptions.forEach((item) => {
          this.dataAuthTableData.forEach((item2) => {
            if (item.personCompanyCode == item2.extendCompanyCode) {
              item.disabled = true;
            }
          });
        });
      },

      // 返回数据
      exportChildData() {
        let returnObj = {};
        returnObj.baseData = this.baseData;
        returnObj.goodsTableData = this.$refs.goodsTable.getTableData().fullData;
        returnObj.dataAuthTableData = this.dataAuthTableData; //this.$refs.dataAuthTable.getTableData().fullData;
        returnObj.goodsTableData.map((item) => {
          item.detailProductDisplayName = this.getDetailProductDisplayName(item);
        });
        returnObj.ids = this.ids;
        return returnObj;
        //this.$emit('success', '1');
      },
      // 新增or修改执行不同数据策略
      resolveData() {
        let dataAuthTableData = [];
        if (
          this.$route.name === 'editGoods' ||
          this.$route.name === 'goodsDetail' ||
          this.$route.name === 'addDetailGoods' ||
          this.$route.name === 'forbidenGoods'
        ) {
          this.baseData = {
            ...this.baseData,
            ...this.goodsDetail,
            ...(this.goodsDetail || {}).customs,
          };
          // this.baseData.valueAddedTaxRate= this.goodsDetail.valueAddedTaxRate || null

          this.goodsTableData = this.goodsDetail.productDetails || [];
          dataAuthTableData = this.goodsDetail.permissions
            ? JSON.parse(JSON.stringify(this.goodsDetail.permissions))
            : [];
          // dataAuthTableData.map(item => {
          //   item.permissionDepartmentCode=item.permissionDepartmentCode?item.permissionDepartmentCode.split(','):[];
          //   item.extendCompanyCode = item.permissionCompanyCode;
          //   item.extendCompanyName = item.permissionCompanyName;
          // })
          dataAuthTableData.forEach((item) => {
            item.permissionDepartmentCode = item.permissionDepartmentCode
              ? item.permissionDepartmentCode.split(',')
              : [];
            item.extendCompanyCode = item.permissionCompanyCode;
            item.extendCompanyName = item.permissionCompanyName;
          });
          this.$refs.baseDataForm.clearValidate();
        } else {
          //组织数据权限表格数据
          this.extendList.map((item) => {
            dataAuthTableData.push({
              extendCompanyCode: item.extendCompanyCode,
              extendCompanyName: item.extendCompanyName,
              dataStatus: '0',
            });
          });
        }
        this.dataAuthTableData = dataAuthTableData;
      },
      //暴露第一个tab表格
      exportFirstData(selectedList) {
        let goodsTableData = this.$refs.goodsTable.getTableData().fullData;
        let newGoodsTableData = [];
        goodsTableData.map((item) => {
          let detailProductDisplayName = this.getDetailProductDisplayName(item);
          newGoodsTableData.push({
            detailProductDisplayName: detailProductDisplayName,
            productDetailCode: item.productDetailCode,
            costCourse: 'CBKM2',
            incomeCourse: 'SRKM1',
          });
        });
        this.$emit('changeTableRow', newGoodsTableData, selectedList, this.baseData.basicUnit);
      },
      //tab页关联字段发生变化的时候
      linkTextChange(value) {
        let goodsTableData = this.$refs.goodsTable.getTableData().fullData;
        goodsTableData.map((item) => {
          this.getDetailProductDisplayName(item);
        });
        //校验中文名称
        if (value && value === 'productChName') {
          const params = {
            productChName: this.baseData.productChName,
            id: (this.goodsDetail || {}).id || '',
          };
          if (params.productChName) {
            this.$axios.post(API.CHECK_PRODUCT_DISPLAY_NAME, params).then((res) => {
              if (res.data.code == 10000) {
                this.alertRepeat(res.data.data, res.data.msg);
                this.productRepeatFlag = true;
              } else {
                this.productRepeatFlag = false;
              }
            });
          }
        } else if (value != 'basicUnit') {
          //表格的数据发生变化
          // 保存时再校验显示名称是否重复，否则新增一行后立马点击删除也会触发提示。
          // return
          const params = {
            detailProductDisplayName: value.row.detailProductDisplayName,
            id: value.row.id,
          };
          this.$axios.post(API.CHECK_DETAIL_PRODUCT_DISPLAY_NAME, params).then((res) => {
            if (res.data.code == 10000) {
              this.alertRepeat(res.data.data, res.data.msg);
              this.productDetailsRepeatFlag = true;
            } else {
              this.productDetailsRepeatFlag = false;
            }
          });
        }
        this.$emit(
          'changeText',
          this.baseData.productChName,
          this.baseData.basicUnit,
          goodsTableData
        );
      },
      alertRepeat(value, msg) {
        this.$repeatAlert(
          "<div><img src='/static/img/tips.png'/>" +
            "<div class='repeatContent'>" +
            msg +
            '</div></div>',
          '',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('confirm.repeat'),
            center: true,
            callback: (action) => {
              if (action == 'confirm') {
                let path = {
                  path: '/masterData/goodsDetail',
                  name: 'goodsDetail',
                  meta: {
                    keepAlive: true,
                    title: this.$t('goods.title.goodsDetail'),
                  },
                  query: {
                    propsGoodsId: value,
                  },
                };
                this.$store.dispatch('tagsView/addTabView', path).then(() => {
                  this.$nextTick(() => {
                    this.$router.push(path);
                  });
                });
              }
            },
          }
        );
      },
      //校验
      validateAll() {
        if (this.productRepeatFlag) {
          this.linkTextChange('productChName');
          return false;
        }
        if (this.productRepeatFlag || this.productDetailsRepeatFlag) {
          //有重复标记
          this.$message({
            showClose: true,
            message: this.$t('goods.message.productDetailsRepeated'),
            type: 'error',
          });
          return;
        }
        let _self = this;
        let promiseObjectList = [];
        function validates(formName) {
          let promiseObject = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              valid ? resolve() : reject();
            });
          });
          promiseObjectList.push(promiseObject);
        }
        validates('baseDataForm');
        validates('goodsTable');
        validates('dataAuthTable');
        return Promise.all(promiseObjectList)
          .then(() => {
            return true;
          })
          .catch(() => {});
      },
      //管理员获取多个公司的下拉
      getextendList() {
        // if(this.userInfo.adminFlag==1){
        const params = {
          adminFlag: 1,
          tenantCode: this.userInfo.tenantCode,
        };
        this.$axios.post(BASE_API.LIST_COMPANY_API, params).then((res) => {
          if (res.data.code === 0) {
            this.companyOptions = res.data.data;
            this.companyOptions.map((item) => {
              item.key = item.id;
              item.personCompanyCode = item.id;
              // item.label = item.label;
              item.personCompanyName = item.label;
            });
          }
        });
        // }else{
        //   const params = {
        //     userid: this.userInfo.userCode,
        //     tenantCode: this.userInfo.tenantCode,
        //     id: this.userInfo.userCode
        //   };
        //   this.$axios.post(API.LIST_PERSON, params).then(res => {
        //     if (res.data.code === 0) {
        //       this.companyOptions = res.data.data.personCompanyInfo;
        //       this.companyOptions.map((item) => {
        //         item.key = item.personCompanyCode;
        //         item.label = item.personCompanyName;
        //       })
        //     }
        //   })
        // }
      },
      //单位转换
      transferSelect(value, list, valueProp = 'key', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //判断子类是否有已驳回
      determineSubclassesRejected() {
        if (this.goodsTableData.length != 0) {
          this.goodsTableData.map((item) => {
            if (item.detailProductStatus == 'ZT05') {
              this.$emit('determineSubclassesRejected', false);
              return;
            } else {
              this.$emit('determineSubclassesRejected', true);
            }
          });
        } else {
          this.$emit('determineSubclassesRejected', true);
        }
      },
      //禁用子类
      forbidChildren() {
        const selectedList = this.$refs['goodsTable'].getCheckboxRecords(); // 获取选中数据
        if (selectedList.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('supplyChain.message.pleaseSelectOne'),
            type: 'error',
          });
        }
        //判断选中数据是否有不是禁用和生效状态的
        let hasErrorStatus = false;
        selectedList.map((item) => {
          if (item.detailProductStatus != 'ZT03') {
            //有不是已生效的子类 不能禁用操作
            hasErrorStatus = true;
          }
        });
        if (hasErrorStatus) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.onlyActiveDisabledDisabled'),
            type: 'error',
          });
          return;
        }
        this.$emit('updateChoosenDetailStatus', selectedList, 1);
      },
      //解禁用子类
      solveForbidChildren() {
        const selectedList = this.$refs['goodsTable'].getCheckboxRecords(); // 获取选中数据
        if (selectedList.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('supplyChain.message.pleaseSelectOne'),
            type: 'error',
          });
        }
        //判断选中数据是否有不是禁用和生效状态的
        let hasErrorStatus = false;
        selectedList.map((item) => {
          if (item.detailProductStatus != 'ZT04') {
            //有非已禁用的数据
            hasErrorStatus = true;
          }
        });
        if (hasErrorStatus) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.onlyDisabledUnblocked'),
            type: 'error',
          });
          return;
        }
        this.$emit('updateChoosenDetailStatus', selectedList, 0);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .wchgData {
    margin-bottom: 60px;
  }
  .wchgData .rowTitle {
    height: 40px;
    line-height: 40px;
    margin-bottom: 15px;
  }
  .wchgData .inputWidth {
    width: 100% !important;
  }
  .vxe-button {
    min-width: 100px;
    border-radius: 2px;
    color: #fff;
  }
  .wchgData .tableStyle {
    margin-bottom: 20px;
  }
  .wchgData .selectAuth {
    width: 100%;
  }
</style>
